import React, {Component} from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import BurgerMenuItemThirdLevel from './BurgerMenuItemThirdLevel'

export default class MegaMenuItemSecondLevel extends Component {
  static propTypes = {
    title: PropTypes.string,
    url: PropTypes.string.isRequired,
    hasChildren: PropTypes.bool,
    subtree:  PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
    ]),
    obfuscate: PropTypes.bool,
    disableForLanguage: PropTypes.bool,
    class: PropTypes.string,
    classStyle: PropTypes.string,
    backBtnHandler: PropTypes.func,
    setThirdLevelTitle: PropTypes.func,
    obfuscateDataUrl: PropTypes.string,
    attributes: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
    ]),
    backButtonLabel: PropTypes.string,
    levelsHandler: PropTypes.func,
  }

  static defaultProps = {
    title: '',
    url: '',
    hasChildren: false,
    subtree: null,
    obfuscate: false,
    disableForLanguage: false,
    class: '',
    classStyle: ''
  }

  state = {
    thirdLevelIsOpen: false
  }

  openMenuThirdLevel = () => {
    const {
      title,
      levelsHandler,
      setThirdLevelTitle,
    } = this.props
    this.setState({thirdLevelIsOpen: true})
    levelsHandler('third')
    setThirdLevelTitle(title)
  }

  closeMenuThirdLevel = () => {
    setTimeout(() => {
      this.setState({thirdLevelIsOpen: false})
    }, 500) // time to render sliding animation
  }

  backBtnHandler = () => {
    const {
      backBtnHandler
    } = this.props

    backBtnHandler()
    this.closeMenuThirdLevel()

  }

  renderLink = () => {
    const {
      title,
      url,
      subtree,
      obfuscate,
      obfuscateDataUrl,
      attributes,

    } = this.props

    let classFromBO = ''
    let targetFromBO = ''

    if (typeof attributes === 'object') {
      classFromBO = attributes.class
      targetFromBO = attributes.target
    }

    const hasChildren = Object.keys(subtree).length > 0

    if (obfuscate && !hasChildren) {
      // obfuscated link
      return (
        <span className={cn('obfuscate', classFromBO)} data-link={obfuscateDataUrl} data-target={targetFromBO}>
          {title}
        </span>
      )
    } else if (hasChildren) {
      // Second level trigger
      return (
        <span className={cn('hasChildren')} onClick={this.openMenuThirdLevel}>
          {title}
        </span>
      )
    } else {
      // default link
      return (
        <a href={url} className={cn(classFromBO)} data-target={targetFromBO}>
          {title}
        </a>
      )
    }
  }

  render() {
    const {
      classStyle,
      subtree,
      disableForLanguage,
      backButtonLabel,
    } = this.props

    const {
      thirdLevelIsOpen,
    } = this.state

    return (
      <React.Fragment>
          {!disableForLanguage &&
            <div
              role="presentation"
              className={cn('mobile-menu__item', classStyle)}
            >
              {this.renderLink()}
              {thirdLevelIsOpen &&
                <div className="mobile-menu__third-level">
                  <div className="mobile-menu__back-btn" onClick={this.backBtnHandler}>
                    {backButtonLabel}
                  </div>
                  {Object.keys(subtree).map((key, index) => {
                      {
                        return <BurgerMenuItemThirdLevel
                          {...subtree[key]}
                          key={index}
                        />
                      }
                    }
                  )}
                </div>
              }
            </div>
          }
      </React.Fragment>
    )
  }
}
